import { Component, OnInit, computed, inject, signal } from '@angular/core'
import { Router, RouterOutlet, NavigationEnd } from '@angular/router'
import { RaidenRoutingService } from './FuseQ/fuseq-raiden/fuseqRaidenRouting.service'
import { MaintenanceService } from './_shared/maintenance/maintenance.service'
import { MaintenanceOverlayComponent } from './_shared/maintenance/maintenance-overlay.component'

import { OptimUiSharedModule } from './shared/optimus-ui-shared.module';
@Component({
    selector: 'app-root',
    template: `<router-outlet></router-outlet>
    @if (showMaintenanceOverlay()) {
      <fq-maintenance-overlay></fq-maintenance-overlay>
    }
    <p-confirmdialog [style]="{ width: '420px' }" [closeOnEscape]="true"></p-confirmdialog>
    <p-toast position="top-right" [preventOpenDuplicates]="true"></p-toast>
    <p-toast key="raiden" position="bottom-right">
      <ng-template pTemplate="message" let-message>
        <div class="flex flex-col gap-1">
          <span class="truncate font-bold">{{ message?.summary }}</span>
          @if (message?.data?.description) { <small>{{ message.data.description }}</small> }
          @if (message?.data?.progress) { <div class="uppercase text-xs font-bold">{{ message.data.progress }}</div> }
        </div>
      </ng-template>
    </p-toast>`,
    standalone: true,
    imports: [OptimUiSharedModule, RouterOutlet, MaintenanceOverlayComponent]
})
export class AppComponent implements OnInit {
    private readonly maintenance = inject(MaintenanceService)
    private readonly currentUrl = signal('')

    /** Overlay bloccante: solo se maintenance attiva senza bypass e display=overlay. */
    readonly showMaintenanceOverlay = computed(() =>
        this.maintenance.blockMode() === 'overlay' && !this.currentUrl().startsWith('/maintenance'))

    constructor(private readonly router: Router, private readonly raiden: RaidenRoutingService) { }
    ngOnInit() {
        this.currentUrl.set(this.router.url)
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return
            }
            this.currentUrl.set(evt.urlAfterRedirects)
            window.scrollTo(0, 0)
        })
    }
}
